
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function SubscriptionTerms() {
  const sections = [
    {
      number: '1',
      title: 'Pricing',
      content: `Pricing for MandaPost's paid service account varies based on different subscription periods. For the prices for each type of subscription account, please refer to the official announcement on the MandaPost's official website.

Please be advised that our subscription fees are subject to modification; however, MandaPost will provide you with prior notification before implementing any such changes.`,
    },
    {
      number: '2',
      title: 'Service Provider',
      content: `Osem Dynamics LLC (hereinafter referred to as "Osem Dynamics" or "we" or "our" or "us") only charge subscribers for the subscription fee. If you are accessing and using the services on behalf of a company (such as your employer) or other legal entity, you represent and warrant that you have the authority to bind that company or other legal entity to these Terms. In that case, "you" and "your" will refer to that company or other legal entity.`,
    },
    {
      number: '3',
      title: 'Service Information',
      content: `All information regarding the specific content, functions, service standards, paid service packages, service periods, subscription fees, and fee composition of MandaPost's paid services shall be subject to the official announcement on the MandaPost's official website and will be listed on your order page. Before subscribing to MandaPost's paid services, you are advised to thoroughly review, comprehend, and confirm the information provided on MandaPost's official website and your order page. Osem Dynamics LLC shall not be held liable for any inaccuracies in the subscription or for any failure of the subscribed services to meet your needs resulting from your own actions or decisions.`,
    },
    {
      number: '4',
      title: 'Payment Methods',
      content: `MandaPost provides you with a variety of convenient payment methods, which are subject to the official announcement on the MandaPost's official website. You can choose to complete your payment in your preferred manner. All subscription fees are paid in the currency shown at the time of payment (unless otherwise stated during the payment process), non-cancelable, non-refundable (except as otherwise expressly set forth in these Terms), and not subject to setoff.`,
    },
    {
      number: '5',
      title: 'Service Activation',
      content: `MandaPost will only provide you with MandaPost's paid services after you completed the payment. Osem Dynamics LLC has no obligation to provide you with any services and/or technical support before you fully pay the agreed subscription fees, except for the free services announced on the MandaPost's official website on our own will.`,
    },
    {
      number: '6',
      title: 'Refund Policy',
      content: `Unless required by applicable law, you will not receive a refund of any portion of the subscription fees paid.`,
    },
    {
      number: '7',
      title: 'Payment Processing',
      content: `We will not collect, store, or process any Personal Data during payment transactions, including but not limited to your name, financial information (bank account number, bank name, Swift code, Billing Address), etc. The aforementioned data is processed by the payment service provider Stripe (https://stripe.com/legal) and the payment is completed with your final confirmation. Please review Stripe's privacy policy for more information.`,
    },
    {
      number: '8',
      title: 'Recurring Payments',
      content: `By agreeing to these Terms and purchasing paid services, you acknowledge that your subscription has recurring payment features and you accept responsibility for all recurring payment obligations prior to cancellation of your subscription by you, or alternatively, you have the option to decline such recurring payment during your initial payment. Upon the completion of the initial payment, we (or our third party payment processor, i.e. Stripe) will automatically charge you, provided that you did not cancel the automatic payment option at the time of initial payment, the corresponding subscription fees in accordance with type of your subscription (e.g., each month or year), on the next payment date corresponding to the commencement of your subscription. If you decide not to continue using the subscribed services, please be sure to cancel your subscription on your account management page before the next payment date. In the event your subscription begins on a day not contained in a later month, your recurring payment will be charged on such other day as we deem appropriate. For example, if you started a monthly subscription on January 31st, your next payment date is likely to be February 28th.`,
    },
    {
      number: '9',
      title: 'Taxes',
      content: `All subscription fees do not include taxes, and you agree to: (a) pay all sales/use, value-added, personal property, or other tax (including any interest and penalties) with respect to the transactions and payments under these Terms, other than taxes based on our income, employees, or real property; and (b) be responsible for any filing of any information or tax returns with respect thereto. If we were required to collect a tax and did not do so at the time of sale, we reserve the right to later charge you for the applicable tax.`,
    },
    {
      number: '10',
      title: 'Withholding',
      content: `All payments made by you to us under these Terms exclude any deduction or withholding. If any such deduction or withholding is required by applicable law, you will pay such additional amounts as are necessary so that the net amount received by us after such deduction or withholding will be equal to the full amount that we would have received if no deduction or withholding had been required. Each party will use commercially reasonable efforts to work with the other party to help obtain, reduce, or eliminate any necessary withholding, deduction, or royalty tax exemptions where applicable.`,
    },
    {
      number: '11',
      title: 'Promotional Activities',
      content: `You fully understand that any complimentary service items or promotional activities within the MandaPost's fee structure are one-time special offers addition to the normal subscription fees. Such complimentary service items or promotional activities shall not be redeemable for cash and/or credit against subscription fees.`,
    },
    {
      number: '12',
      title: 'Contact Us',
      content: `In the event of any questions or for more details on the aforementioned, please refer to the answers in the FAQ or send your questions to support@mandapost.com. We will respond to you and provide feedback on the questions you raise within seven (7) business days after receiving your questions.`,
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-[#e4f4ff]/20 via-white to-[#b3d9ff]/10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
            <i className="ri-file-text-line mr-2"></i>
            Legal Terms
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-[#22577A] mb-6">
            Subscription Terms
          </h1>

          <div className="flex items-center gap-2 text-gray-600">
            <i className="ri-calendar-line"></i>
            <p className="text-lg">
              <strong>Effective Date:</strong> January 1, 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Introduction */}
          <div className="bg-gradient-to-br from-[#e4f4ff]/20 to-[#b3d9ff]/20 rounded-2xl border-2 border-[#66b3ff]/30 p-8 mb-12">
            <p className="text-lg text-gray-800 leading-relaxed">
              Please read these MandaPost Subscription Terms (the "Terms") carefully because they govern your use of the subscription service of MandaPost.
            </p>
          </div>

          {/* Terms Sections */}
          <div className="space-y-8">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white rounded-xl border-2 border-gray-200 p-8 hover:border-[#66b3ff] transition-colors"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-lg flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold">{section.number}</span>
                  </div>
                  <h2 className="text-2xl font-bold text-[#22577A] mt-1">{section.title}</h2>
                </div>
                <div className="ml-14">
                  {section.content.split('\n\n').map((paragraph, pIndex) => (
                    <p key={pIndex} className="text-gray-700 leading-relaxed mb-4 last:mb-0">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Contact CTA */}
          <div className="mt-12 bg-gradient-to-r from-[#22577A] to-[#38a3a5] rounded-2xl p-8 text-white">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-question-line text-2xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-bold mb-2">Have Questions?</h3>
                <p className="text-white/90 mb-4">
                  If you have any questions about these subscription terms, please don't hesitate to contact us.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="/contact"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#22577A] rounded-lg font-semibold hover:shadow-xl transition-all cursor-pointer"
                  >
                    <i className="ri-mail-line"></i>
                    Contact Support
                  </a>
                  <a
                    href="/pricing"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-all cursor-pointer"
                  >
                    <i className="ri-price-tag-3-line"></i>
                    View Pricing
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Related Links */}
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            <a
              href="#"
              className="block bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-xl p-6 border-2 border-[#66b3ff]/30 hover:border-[#66b3ff] hover:shadow-lg transition-all group"
            >
              <i className="ri-shield-check-line text-3xl text-[#22577A] mb-3"></i>
              <h3 className="text-lg font-bold text-[#22577A] mb-2 group-hover:text-[#38a3a5] transition-colors">
                Privacy Policy
              </h3>
              <p className="text-sm text-gray-600">
                Learn how we protect your data
              </p>
            </a>

            <a
              href="#"
              className="block bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-xl p-6 border-2 border-[#66b3ff]/30 hover:border-[#66b3ff] hover:shadow-lg transition-all group"
            >
              <i className="ri-file-list-3-line text-3xl text-[#22577A] mb-3"></i>
              <h3 className="text-lg font-bold text-[#22577A] mb-2 group-hover:text-[#38a3a5] transition-colors">
                Terms of Service
              </h3>
              <p className="text-sm text-gray-600">
                Review our service terms
              </p>
            </a>

            <a
              href="#"
              className="block bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/30 rounded-xl p-6 border-2 border-[#66b3ff]/30 hover:border-[#66b3ff] hover:shadow-lg transition-all group"
            >
              <i className="ri-question-answer-line text-3xl text-[#22577A] mb-3"></i>
              <h3 className="text-lg font-bold text-[#22577A] mb-2 group-hover:text-[#38a3a5] transition-colors">
                FAQ
              </h3>
              <p className="text-sm text-gray-600">
                Find answers to common questions
              </p>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
